import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuth } from "../features/userSlice";
import { MenuIcon } from "../assets/SvgConstant";
import Logo from "../assets/logo.jpg";
import themeColors from "../theme/ThemeColors";
import { BellDotIcon, BellPlus } from "lucide-react";
const Navbar = ({ isExpanded, setExpanded }) => {
  const [open, setOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // 🔐 Get logged-in user
  // const user = JSON.parse(localStorage.getItem("user"));

  // if (!user) return nuconstll;
  // const user = {
  //   name: "John Doe",
  //   role: "MANAGER",
  //   branchId: { branchName: "Main Branch" },
  // };

  const initials = user?.name?.charAt(0).toUpperCase();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(clearAuth());
    navigate("/");
  };
  console.log("USer", user);
  return (
    <nav className="w-full bg-white border-b border-gray-200 shadow-sm">
      <div className="pr-4 w-full">
        <div className="flex h-14 items-center justify-between">
          {/* Logo */}
          <div className="w-16 flex justify-center px-6 ">
            <div
              className="cursor-pointer"
              onClick={() => {
                setExpanded(!isExpanded);
              }}
            >
              <MenuIcon />
            </div>
          </div>
          <div className="flex items-center w-full gap-4 ">
            <div className="flex items-center gap-2">
              {/* <div className="w-10 h-9 rounded-lg bg-sky-600 text-white flex items-center justify-center font-bold">
                OPS
              </div> */}
              <img
                src={Logo}
                alt="Logo"
                className="w-10 h-10 object-contain rounded-lg"
              />
              <span
                style={{
                  color: themeColors.primary,
                }}
                className="font-semibold text-gray-800 text-lg"
              >
                Odisha Parcel Service
              </span>
            </div>
          </div>

          {/* Desktop Right Section */}
          <div className="hidden md:flex items-center gap-6">
            {/* Branch Info */}
            <div className="px-4 py-2 rounded-lg bg-sky-600 text-white text-sm font-medium whitespace-nowrap">
              {user?.role === "MANAGER"
                ? "All Branches"
                : user?.branch?.name || "Branch"}
            </div>

            {/* Notification */}
            <div className="relative cursor-pointer">
              {/* <span className="text-xl hover:text-sky-600 transition">🔔</span> */}
              <BellDotIcon />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-1.5 rounded-full">
                3
              </span>
            </div>

            {/* Profile */}
            <div className="relative">
              <button
                onClick={() => setProfileOpen((prev) => !prev)}
                className="flex items-center gap-2 border border-sky-200 rounded-lg p-2  hover:bg-gray-50 transition"
              >
                <div className="w-8 h-8 rounded-full bg-sky-600 text-white flex items-center justify-center text-sm font-semibold">
                  {initials}
                </div>
                <div className="text-left">
                  <div className="text-xs font-medium text-gray-700">
                    {user?.name?.split(" ")[0]}
                  </div>
                  <div className="text-xs text-gray-500">
                    {user?.role === "MANAGER" ? "Manager" : "Employee"}
                  </div>
                </div>
              </button>

              {/* Profile Dropdown */}
              {profileOpen && (
                <div className="absolute right-0 mt-2 w-40 bg-white border border-sky-200 rounded-lg shadow-md overflow-hidden z-50">
                  <button
                    onClick={() => navigate("/profile")}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Profile
                  </button>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-gray-700 text-2xl"
          >
            {open ? "✖" : "☰"}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-sm">
          <div className="flex flex-col px-4 py-3 gap-3">
            {/* Branch */}
            <div className="w-full py-2 rounded-lg bg-sky-600 text-white text-sm font-medium text-center">
              {user?.role === "MANAGER"
                ? "All Branches"
                : user?.branch?.name || "Branch"}
            </div>

            <button className="flex items-center gap-2 py-2 text-gray-700">
              🔔 Notifications
            </button>

            {/* Mobile Profile */}
            <div className="flex items-center gap-3 pt-3 border-t border-sky-200">
              <div className="w-9 h-9 rounded-full bg-sky-600 text-white flex items-center justify-center font-semibold">
                {initials}
              </div>
              <div>
                <div className="text-sm font-medium">{user?.name}</div>
                <div className="text-xs text-gray-500">
                  {user?.role === "MANAGER" ? "Manager" : "Employee"}
                </div>
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="text-left text-red-600 text-sm pt-2"
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
